"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ArrowDoubleRight;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ArrowDoubleRight(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "arrow-double-right"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M62.817,47.61,23.441,8.232a2.5,2.5,0,1,0-3.535,3.536L58.137,50,19.9,88.232a2.5,2.5,0,1,0,3.535,3.536L62.82,52.388A3.386,3.386,0,0,0,62.817,47.61Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M79.839,47.61,40.463,8.232a2.5,2.5,0,1,0-3.535,3.536L75.158,50,36.926,88.232a2.5,2.5,0,1,0,3.535,3.536l39.381-39.38A3.387,3.387,0,0,0,79.839,47.61Z"
  })))));
}